import dispatcher from './dispatcher';
import { BASE_URL } from './AppConst';
import axios from 'axios';
import {
  VIEW_LOGIN_ID,
  VIEW_LOGIN_ID_ERR,
  SUCCESS,
  FAILED,
  DISMISS,
  VIEW_STUDENTS,
  ON_ERROR,
} from './Actions';

export const GetLoginID = async () => {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );

  const response = await axios.get('/ids');

  console.log(response.data);

  if (response) {
    dispatcher.dispatch({
      type: VIEW_LOGIN_ID,
      payload: response.data,
    });
  } else {
    dispatcher.dispatch({
      type: VIEW_LOGIN_ID_ERR,
      payload: [],
    });
  }

  // .then((res) => {
  //   const status = parseInt(res.data.status);

  //   if (status === 200) {
  //     const responseString = JSON.parse(JSON.stringify(res.data));
  //     let generated_ids = responseString.data;
  //     dispatcher.dispatch({
  //       type: VIEW_LOGIN_ID,
  //       payload: generated_ids,
  //     });
  //   } else {

  //   }
  // })
  // .catch((error) => console.log(`Error Encountered ${error}`));
};

export const GenerateLogin = async (postData) => {
  const { qty } = postData;
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );

  const response = await axios.put('/generate', { qty });
  if (response) {
    dispatcher.dispatch({
      type: SUCCESS,
    });
  } else {
    dispatcher.dispatch({
      type: FAILED,
      payload: [],
    });
  }
};

export const GetStudents = async () => {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );

  const response = await axios.get('/students');

  if (response.data) {
    dispatcher.dispatch({
      type: VIEW_STUDENTS,
      payload: response.data,
    });
  } else {
    dispatcher.dispatch({
      type: FAILED,
      payload: [],
    });
  }
};

export const ResetAttempt = async ({ id }) => {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );

  try {
    const response = await axios.put('/reset/' + id);

    if (response.data) {
      dispatcher.dispatch({
        type: VIEW_STUDENTS,
        payload: response.data,
      });
    } else {
      dispatcher.dispatch({
        type: VIEW_STUDENTS,
        payload: [],
      });
    }
  } catch (error) {
    dispatcher.dispatch({
      type: ON_ERROR,
      payload: error,
    });
  }
};

export const DeleteID = async (postData) => {
  const { id } = postData;

  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );

  const response = await axios.delete('/ids/' + id);

  if (response.data) {
    dispatcher.dispatch({
      type: VIEW_LOGIN_ID,
      payload: response.data,
    });
  } else {
    dispatcher.dispatch({
      type: FAILED,
      payload: [],
    });
  }
};

export function DeleteStudent(postData) {
  const { id } = postData;

  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );
  axios
    .post('/students/delete/' + id, {})
    .then((res) => {
      const status = parseInt(res.data.status);

      if (status === 200) {
        const responseString = JSON.parse(JSON.stringify(res.data));
        let students = responseString.data;
        dispatcher.dispatch({
          type: VIEW_STUDENTS,
          payload: students,
        });
      } else {
        dispatcher.dispatch({
          type: FAILED,
          payload: [],
        });
      }
    })
    .catch((error) => console.log(`Error Encountered ${error}`));
}

function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
  );
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function DownloadIDs() {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );
  axios
    .post('/students/export-ids', {})
    .then((res) => {
      const status = parseInt(res.data.status);

      if (status === 200) {
        const responseString = JSON.parse(JSON.stringify(res.data));
        let exportIds = responseString.data;
        download('STUDENT_IDS.txt', JSON.stringify(exportIds));
        dispatcher.dispatch({
          type: SUCCESS,
        });
      } else {
        dispatcher.dispatch({
          type: FAILED,
          payload: [],
        });
      }
    })
    .catch((error) => console.log(`Error Encountered ${error}`));
}

export function DissMiss() {
  dispatcher.dispatch({
    type: DISMISS,
  });
}
